import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbCalendar, NgbDateParserFormatter, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from 'src/app/helpers/ngb-date-custom-parser-formatter';
import { OfferHttpService } from 'src/app/http/offer-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';

@Component({
    selector: 'app-discount-period',
    templateUrl: './discount-period.component.html',
    styles: [],
})
export class DiscountPeriodComponent implements OnInit {
    constructor(
        private calendar: NgbCalendar,
        public formatter: NgbDateParserFormatter,
        private fb: FormBuilder,
        private ngbDateParserFormatter: NgbDateCustomParserFormatter,
        private offerHttpService: OfferHttpService,
        private activatedRoute: ActivatedRoute
    ) {}

    fromDate: NgbDate | null;

    toDate: NgbDate | null;

    periodDiscountForm = this.fb.group(
        {
            discountPeriodId: [0],
            discountPeriodValue: [null],
        },
        { updateOn: 'submit' }
    );

    hoveredDate: NgbDate | null = null;

    formBusy: boolean;

    discountPeroid: any;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.discountPeroid = data.data;
            this.patchForm(data.data);
        });
    }

    patchForm(item: any) {
        if (this.discountPeroid) {
            const dateFrom = new Date(item.discountPeriodFrom);
            const dateTo = new Date(item.discountPeriodTo);
            const parsedDateFrom = this.ngbDateParserFormatter.parse(dateFrom.toLocaleDateString('en-US'));
            const parsedDateTo = this.ngbDateParserFormatter.parse(dateTo.toLocaleDateString('en-US'));
            this.fromDate = parsedDateFrom as any;
            this.toDate = parsedDateTo as any;
            this.periodDiscountForm.patchValue(item);
        } else {
            this.fromDate = this.calendar.getToday();
            this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 10);
        }
    }

    onSubmit() {
        const fromDate = this.ngbDateParserFormatter.format(this.fromDate);
        const toDate = this.ngbDateParserFormatter.format(this.toDate);

        const discountFormValue = {
            discountPeriodId: this.periodDiscountForm.value.discountPeriodId,
            discountPeriodFrom: fromDate,
            discountPeriodTo: toDate,
            discountPeriodValue: this.periodDiscountForm.value.discountPeriodValue,
        };

        this.formBusy = true;

        this.offerHttpService.updateDiscountPeriod(discountFormValue).subscribe((data) => {
            this.formBusy = false;
            this.alert.addAlert({ type: 'success', message: `Discount Period updated successfully` });
        });
    }

    onDateSelection(date: NgbDate) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
            this.toDate = date;
        } else {
            this.toDate = null;
            this.fromDate = date;
        }
    }

    isHovered(date: NgbDate) {
        return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    }

    isInside(date: NgbDate) {
        return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
        return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
    }

    validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }
}
